// @ts-ignore — formiojs v4 ships without first-class TS types
import { Components } from 'formiojs';
import { createRoot, type Root } from 'react-dom/client';
import PdfViewer from './PdfViewer';
import { pdfViewerSettings } from './PdfViewer.settings';

const Field = Components.components.field;

export default class PdfViewerComp extends Field {
    root: Root | null = null;

    static schema(...extend: any[]) {
        return Field.schema({
            type: 'pdfviewer',
            label: 'Pdf Viewer',
            key: 'pdfViewer',
            pdfViewerDataFrom: 'base64',
            customStyle: 'width: 100%; height: 500px;',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Pdf Viewer',
            group: 'custom',
            icon: 'file-pdf-o',
            weight: 70,
            documentation: '/userguide/#pdfviewer',
            schema: PdfViewerComp.schema(),
        };
    }

    static editForm = () => {
        return pdfViewerSettings;
    }

    get defaultSchema() {
        return PdfViewerComp.schema();
    }

    renderReact(element: HTMLElement) {
        if (!this.root) {
            this.root = createRoot(element);
        }

        this.root.render(
            <PdfViewer
                component={this.component}
                value={this.dataValue}
                data={this.data}
                row={this.row} // For row context in editgrid etc
            />
        );
    }

    attach(element: HTMLElement) {
        // Form.io calls attach when the element is in the DOM
        const ret = super.attach(element);

        // Remove any stale container + React root before re-mounting.
        // FormIO can call attach() again after a save without calling detach()
        // first, which would create a second React root on the same node.
        const old = element.querySelector('.pdf-viewer-react-container');
        if (old) {
            old.remove();
            if (this.root) {
                this.root.unmount();
                this.root = null;
            }
        }

        const container = document.createElement('div');
        container.className = 'pdf-viewer-react-container';
        element.appendChild(container);

        this.renderReact(container);

        return ret;
    }

    detach() {
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }
        return super.detach();
    }

    setValue(value: any, flags: any = {}) {
        const changed = super.setValue(value, flags);
        return changed;
    }
}
